<template>

  <large-modal
      :show="typeof image === 'object'"
      title="Crop media"
      subtitle="Select the crop for this image"
      @close="closeCrop"
      size="max-w-7xl"
  >
    <div v-if="saving" class="flex w-full h-128 justify-center items-center">
      <spinning-circle />
    </div>
    <div
        v-else-if="typeof image === 'object'"
        class="relative"
    >
      <cropper
          :src="image.original_url"
          @change="changeCrop"
          :default-position="cropperDefaultPosition"
          :default-size="cropperDefaultSize"
      />
      <span class="absolute top-0 right-0 bg-gray-800 bg-opacity-50 text-white text-sm">{{ coords.width }} x {{ coords.height }}</span>
    </div>

    <template #footer>
      <template v-if="!saving">
        <button @click="closeCrop" type="button" class="mr-3 inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
          Cancel
        </button>
        <button @click="saveCrop" type="button" class="inline-flex items-center rounded border border-transparent bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
          Save
        </button>
      </template>
    </template>
  </large-modal>
</template>

<script setup>
import LargeModal from "@/ComponentsDeprecated/Modal/LargeModal";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import SpinningCircle from "@/ComponentsDeprecated/Loaders/SpinningCircle";
import {computed, ref} from "vue";

const crop = ref(null)
const saving = ref(false)
const coords = ref(false);

const props = defineProps({
  image: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['close', 'crop'])

function closeCrop() {
  emit('close')
  props.image = null;
}

function changeCrop({ coordinates, canvas }) {
  coords.value = coordinates;
}

function saveCrop() {
  saving.value = true;
  axios.post(route('api.media.crop.store', {media: props.image.id }), {
    height: coords.value.height,
    width: coords.value.width,
    x: coords.value.left,
    y: coords.value.top
  }).then((response) => {
    emit('crop', response.data)
  }).finally(() => {
    saving.value = false;
  })
}

const cropperDefaultSize = computed(() => {
  if(coords.value) return {height: coords.value.height, width: coords.value.width};
  else if(props.image.pivot?.media_crop?.coordinates) return {height: props.image.pivot?.media_crop?.coordinates.height, width: props.image.pivot?.media_crop?.coordinates.width};
  return null
})

const cropperDefaultPosition = computed(() => {
  if(coords.value) return {left: coords.value.left, top: coords.value.top};
  else if(props.image.pivot?.media_crop?.coordinates) return {left: props.image.pivot?.media_crop?.coordinates.left, top: props.image.pivot?.media_crop?.coordinates.top};
  return null
})

</script>
